import { render, staticRenderFns } from "./ValidatableDocumentPersonIdentity.vue?vue&type=template&id=7d62012e&"
import script from "./ValidatableDocumentPersonIdentity.vue?vue&type=script&lang=js&"
export * from "./ValidatableDocumentPersonIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports